import script from "./Indicators.vue?vue&type=script&setup=true&lang=js"
export * from "./Indicators.vue?vue&type=script&setup=true&lang=js"

import "./Indicators.vue?vue&type=style&index=0&id=034fd8ac&lang=scss"

const __exports__ = script;

export default __exports__